import { IRequestModel, HttpMethod, ValidationResponse } from "../../IRequestModel";
import AuthValidation from "../../validation/AuthValidation";

export class RegisterRequest implements IRequestModel {

    constructor(email: string, fullName: string, username: string, password: string) {
        this.full_name = fullName;
        this.email = email;
        this.username = username;
        this.password = password;
    }

    uri: string = "auth/register";
    method: HttpMethod = HttpMethod.POST;

    full_name: string;
    email: string;
    username: string;
    password: string;

    isValid(): ValidationResponse {
        let emailResp: ValidationResponse = AuthValidation.EmailAddressValid(this.email, "Email Address");
        if (!emailResp.isSuccess) {
            return emailResp;
        }

        if (this.full_name.length < 3) {
            return ValidationResponse.Error("Full Name should be at least 3 characters.");
        }
        if (this.full_name.length > 40) {
            return ValidationResponse.Error("Full Name should be at most 40 characters.");
        }

        let usernameResp: ValidationResponse = AuthValidation.UsernameValid(this.username, "Username");
        if (!usernameResp.isSuccess) {
            return usernameResp;
        }

        let passResp: ValidationResponse = AuthValidation.PasswordValid(this.password, "Password");
        return passResp;
    }
}